import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectResultIdsState } from '../../Store/resultSlice';
import { FaCodeCompare } from 'react-icons/fa6';

const CompareButton = () => {
    const navigate = useNavigate();
    const { projectId, imageId } = useParams();
    const selectedResultIds = useSelector(selectResultIdsState);

    const handleCompare = () => {
        if (selectedResultIds.length === 2) {
            navigate(`/projects/${projectId}/images/${imageId}/results/${selectedResultIds[0]}/compare/${selectedResultIds[1]}`);
        }
    };

    if (selectedResultIds.length !== 2) {
        return null;
    }

    return (
        <button
            onClick={handleCompare}
            className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-xs"
        >
            <FaCodeCompare />
            Compare
        </button>
    );
};

export default CompareButton; 